export interface FaqItem {
  question: string;
  answer: string;
}

export const faqList: FaqItem[] = [
  {
    question: 'JavBus 是什么平台？',
    answer: 'JavBus 是一个综合性的影片资料库平台，提供番号查询、影片信息检索、演员资料浏览等功能，帮助用户快速找到所需的影片信息。',
  },
  {
    question: '如何获取 JavBus 的最新访问地址？',
    answer: '本页面"最新地址"栏目持续更新 JavBus 的官方域名和可用镜像站点。建议收藏本页面或将我们的邮箱订阅加入收藏，以便随时获取最新地址信息。',
  },
  {
    question: 'JavBus 搜索功能如何使用？',
    answer: '在搜索框中输入影片番号、演员名或关键词即可搜索。支持完整番号、前缀搜索和模糊匹配。详细教程请参考"搜索技巧"分类下的文章。',
  },
  {
    question: '为什么搜索不到某些番号的结果？',
    answer: '可能的原因包括：番号输入格式有误、该作品尚未进入数据库、或需要使用不同的拼写方式。建议检查番号格式是否正确后重试。',
  },
  {
    question: '使用镜像站点安全吗？',
    answer: '本页面列出的所有镜像站点均经过安全验证，内容与主站保持同步。但建议始终通过官方渠道获取的最新镜像地址，避免点击来源不明的链接。',
  },
  {
    question: 'JavBus 是否需要付费使用？',
    answer: 'JavBus 的基础功能（搜索、浏览）为用户提供免费服务。具体功能和政策请以官方平台最新公告为准。',
  },
  {
    question: '如何向我们反馈问题或提供建议？',
    answer: '您可以通过"关于我们"页面的联系表单提交反馈，我们的团队会在收到信息后尽快处理。',
  },
];